var render, staticRenderFns
import script from "./frozen_detail_table.vue?vue&type=script&lang=js"
export * from "./frozen_detail_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce757f0')) {
      api.createRecord('7ce757f0', component.options)
    } else {
      api.reload('7ce757f0', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_cost_pool/form/components/frozen_detail_table.vue"
export default component.exports